import PropTypes from 'prop-types';
import { Wrapper } from "./styles";

const LoadingScreen = ({ description }) => {
  return <Wrapper>
    <img src="/assets/icons/loading-card.svg" alt="Loading" className="loading-card" />
    <div className="loader"></div>
    {description && <p>{description}</p>}
  </Wrapper>
};

LoadingScreen.propTypes = {
  description: PropTypes.string,
};

export default LoadingScreen;